import { render, staticRenderFns } from "./NewWaybillEntry.vue?vue&type=template&id=8ef33158&scoped=true&"
import script from "./NewWaybillEntry.vue?vue&type=script&lang=js&"
export * from "./NewWaybillEntry.vue?vue&type=script&lang=js&"
import style0 from "./NewWaybillEntry.vue?vue&type=style&index=0&id=8ef33158&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef33158",
  null
  
)

export default component.exports